module.exports = __webpack_public_path__ + "static/media/fk.41f98e7b.svg";